/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Exclamation: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="exclamation" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M744.77 404.77C744.77 373.49 719.3975 348.1175000000001 688.1175000000001 348.1175000000001S631.4650000000001 373.4900000000001 631.4650000000001 404.77C631.4650000000001 436.0500000000001 656.8375000000001 461.4225 688.1175000000001 461.4225S744.77 436.05 744.77 404.77zM688.1175 971.4224999999998C719.3975 971.4224999999998 744.7699999999999 946.05 744.7699999999999 914.77L716.4224999999998 546.4225C716.4224999999998 530.7825 703.7149999999998 518.0749999999999 688.0749999999997 518.0749999999999S659.7274999999997 530.7824999999999 659.7274999999997 546.4225L631.3799999999998 914.77C631.3799999999998 946.05 656.7524999999997 971.4224999999998 688.0324999999997 971.4224999999998z" : "M595.816 323.8160000000001C595.816 298.7920000000001 575.518 278.4940000000002 550.4940000000001 278.4940000000002S505.1720000000001 298.7920000000002 505.1720000000001 323.8160000000001C505.1720000000001 348.8400000000001 525.47 369.1379999999999 550.4940000000001 369.1379999999999S595.816 348.8399999999999 595.816 323.8160000000001zM550.4939999999999 777.1379999999999C575.518 777.1379999999999 595.8159999999999 756.8399999999999 595.8159999999999 731.816L573.1379999999998 437.1379999999999C573.1379999999998 424.626 562.9719999999999 414.4599999999999 550.4599999999998 414.4599999999999S527.7819999999998 424.6259999999999 527.7819999999998 437.1379999999999L505.1039999999998 731.816C505.1039999999998 756.8399999999999 525.4019999999998 777.1379999999999 550.4259999999997 777.1379999999999z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Exclamation.displayName = `Blueprint5.Icon.Exclamation`;
export default Exclamation;
